// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.headerLogo {\n  flex: 1;\n  min-width: 0;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  margin-top: 14px;\n  margin-right: 51px;\n  float: left;\n}\n.logoImg {\n  display: inline-block;\n  width: 141px;\n  height: 36px;\n  margin-right: 17px;\n}\n.logoTxt {\n  display: inline-block;\n  color: #565656;\n  font-size: 12px;\n}\n", ""]);
// Exports
module.exports = exports;
